"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeepEqualEffect = void 0;
const react_1 = require("react");
const _ = require("lodash");
// same as useEffect, but only re-calls the function if the deps deeply change
// should very rarely be used
const useDeepEqualEffect = (fn, deps) => {
    const undoFunc = (0, react_1.useRef)();
    // call undoFunc on unmount (if set)
    (0, react_1.useEffect)(() => () => {
        if (undoFunc.current) {
            undoFunc.current();
        }
    }, []);
    const lastDeps = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (_.isEqual(deps, lastDeps.current)) {
            // nothing has changed, abort
            return;
        }
        // deps has deeply changed
        if (undoFunc.current) {
            // call last stored undoFunc
            undoFunc.current();
        }
        undoFunc.current = fn();
        // store new deps
        lastDeps.current = deps;
    }, [deps]);
};
exports.useDeepEqualEffect = useDeepEqualEffect;
//# sourceMappingURL=useDeepEqualEffect.js.map